import { ApolloClient } from 'apollo-client'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { HttpLink } from 'apollo-link-http'
import { GRAPH_URI } from '../constants'

const mnsClient = new ApolloClient({
  link: new HttpLink({
    uri: `${GRAPH_URI}/subgraphs/name/mnsdomains/mns`,
  }),
  cache: new InMemoryCache(),
})

export default mnsClient
